import '../CSS/Loading.css'
function loading() {
  return (
    <div className="loading">
      <div className="loader-wrapper" id="loader-wrapper">
        <div className="loader">
            <div className="loader loader-inner"></div>
        </div>
    </div>
    <p className='loadingText'>Loading</p>
    </div>
  );
}
export default loading;
